import { useCallback, useEffect } from 'react';

/**
 * Hook to prevent manual scrolling of the marquee
 * @param scrollRef - Reference to the scrollable element
 */
export function usePreventManualScroll(
  scrollRef: React.RefObject<HTMLDivElement>
) {
  const preventManualScroll = useCallback((event: Event) => {
    event.preventDefault();
  }, []);

  useEffect(() => {
    if (!scrollRef.current) {
      return;
    }

    const scrollElement = scrollRef.current;

    scrollElement.addEventListener('wheel', preventManualScroll, {
      passive: false,
    });

    scrollElement.addEventListener('touchmove', preventManualScroll, {
      passive: false,
    });

    return () => {
      scrollElement.removeEventListener('wheel', preventManualScroll);
      scrollElement.removeEventListener('touchmove', preventManualScroll);
    };
  }, [preventManualScroll, scrollRef]);
}
